'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogLevel = function LogLevel(name, value) {
    _classCallCheck(this, LogLevel);

    this.name = '';
    this.value = 9999;

    if (typeof name !== 'string' || !name) {
        throw new Error('The given name (' + name + ') is not a valid string.');
    }
    if (typeof value !== 'number') {
        throw new Error('The given value (' + value + ') is not a valid number.');
    }

    this.name = String(name || '');
    this.value = Number(value) || 0;
};

exports['default'] = LogLevel;